interface QueryParams {
  [key: string]:
    | string
    | number
    | boolean
    | Array<string | number | boolean>
    | null
    | undefined
}

const formatURL = (
  url: string,
  queries?: QueryParams,
  fetchCondition: boolean = true
): string | null => {
  if (fetchCondition) {
    let params = null
    if (queries) {
      params = Object.keys(queries)
        .map(key => {
          if (queries[key] !== null && queries[key] !== undefined) {
            if (Array.isArray(queries[key])) {
              return (queries[key] as Array<string | number | boolean>)
                .map(
                  value =>
                    `${encodeURIComponent(key)}=${encodeURIComponent(
                      String(value)
                    )}`
                )
                .join('&')
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(
              String(queries[key])
            )}`
          } else return null
        })
        .filter(e => e)
        .join('&')
    }
    return url + (params ? '?' + params : '')
  } else return null
}

export default formatURL
